/**
 * Normalize equipment / Mongo ids from API (string, ObjectId, { _id }, { $oid }) for stable === comparisons.
 */

export function normalizeEquipmentId(id: unknown): string | null {
  if (id == null || id === '') return null;
  if (typeof id === 'string') {
    const t = id.trim();
    return t.length ? t : null;
  }
  if (typeof id === 'object' && id !== null) {
    const o = id as Record<string, unknown>;
    if (typeof o.$oid === 'string') return o.$oid;
    if (o._id != null) return normalizeEquipmentId(o._id);
    if (o.id != null) return normalizeEquipmentId(o.id);
  }
  try {
    return String(id);
  } catch {
    return null;
  }
}
